import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Typeahead, TypeaheadComponentProps } from "react-bootstrap-typeahead";

export interface FormikTypeaheadProps extends TypeaheadComponentProps {
  name: string;
}

const FormikTypeahead = ({
  options,
  name,
  renderMenuItemChildren,
  ...props
}: FormikTypeaheadProps) => {
  const {
    setFieldTouched,
    getFieldMeta,
    handleChange: formikChange,
    validateField,
  } = useFormikContext();

  const { touched, error, value } = getFieldMeta(name);

  const [selectedOption, setSelectedOption] = useState<any | null>(null);

  useEffect(() => {
    if (value) {
      const selected = options.find((o: any) => o.value === value);
      if (selected) {
        setSelectedOption(selected);
      }
    }
  }, [value]);

  const onBlur = () => {
    setFieldTouched(name, true);
    validateField(name);
  };

  const handleChange = (selected: any) => {
    if (selected.length > 0) {
      const s = selected[0];
      formikChange({ target: { name, value: s.value } });
    } else {
      formikChange({ target: { name, value: "" } });
      setSelectedOption(null);
    }
  };

  return (
    <>
      <Typeahead
        id="oi"
        options={options}
        isInvalid={touched && !!error}
        onChange={handleChange}
        onBlur={onBlur}
        clearButton
        renderMenuItemChildren={renderMenuItemChildren}
        selected={selectedOption ? [selectedOption] : []}
      />
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </>
  );
};

export default FormikTypeahead;
